import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet, apiPut } from 'APIPackage/MainModule/common/apiTools';

import { IAdminSetting } from '../interfaces/IAdminSetting';

export async function fetchSettingsSchedule(): Promise<IAdminSetting[]> {
  return apiGet<IAdminSetting[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/settings/schedule`);
}

export async function updateSettingSchedule(body: IAdminSetting[]): Promise<void> {
  return apiPut<void>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/settings/schedule`, body);
}
